export default __webpack_public_path__ + "static/media/loading.9beffcf8.svg";